"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useProcess = void 0;
var useAsyncAction_1 = require("./useAsyncAction");
var useProcess = function () {
    var _a = useAsyncAction_1.useAsyncAction(200), trigger = _a.trigger, state = _a.state, error = _a.error, result = _a.result;
    return {
        result: result,
        error: error,
        processed: state.complete,
        processing: state.triggered,
        processingSlowly: state.slow,
        process: function (processDelegate) {
            var args = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args[_i - 1] = arguments[_i];
            }
            return trigger.apply(void 0, __spreadArray([processDelegate], args));
        },
    };
};
exports.useProcess = useProcess;
//# sourceMappingURL=useProcess.js.map